export default {
  // Still used by the report Landing page (InsightsLabBanner). The Insights Lab
  // index page moved this disclaimer into the header (view.disclaimer) instead.
  banner: {
    title: 'REPORT CONTENT AND AVAILABILITY MAY CHANGE OVER TIME',
    description:
      'These reports are updated regularly in response to evolving business needs of our brands. Reports may be refined, repositioned, or removed as new data or feedback becomes available.',
  },
  view: {
    title: 'Insights Lab',
    title_v2: 'All reports',
    subtitle:
      'Discover insights that reveal trends in customer behavior and uncover opportunities.',
    disclaimer: 'Report content and availability may change over time',
    disclaimer_tooltip:
      'These reports are updated regularly in response to evolving business needs of our brands. Reports may be refined, repositioned, or removed as new data or feedback becomes available.',
  },
  report_item: {
    view_report: 'View Report',
  },
  categories: {
    all: 'All reports',
  },
}
